"use strict";
/**
 * @module Services.Control
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var serialiser_1 = require("./../../serialisers/serialiser");
var session_id_serialiser_1 = require("./../../session/session-id-serialiser");
var close_client_request_1 = require("./close-client-request");
/**
 * Serialiser for {@link CloseClientRequest}
 */
var CloseClientRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(CloseClientRequestSerialiserClass, _super);
    function CloseClientRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link CloseClientRequest} from the stream
     *
     * @param bis the input stream
     * @return    the {@link CloseClientRequest} that was read
     */
    CloseClientRequestSerialiserClass.prototype.read = function (bis) {
        var sessionID = session_id_serialiser_1.SessionIdSerialiser.read(bis);
        return new close_client_request_1.CloseClientRequest(sessionID);
    };
    /**
     * Write a {@link CloseClientRequest} to the stream
     *
     * @param bos   the output stream
     * @param value the {@link CloseClientRequest} to be written
     */
    CloseClientRequestSerialiserClass.prototype.write = function (bos, value) {
        session_id_serialiser_1.SessionIdSerialiser.write(bos, value.sessionID);
    };
    return CloseClientRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.CloseClientRequestSerialiserClass = CloseClientRequestSerialiserClass;
/**
 * The {@link SecurityCommandScriptResultSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.CloseClientRequestSerialiser = new CloseClientRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/close-client-request-serialiser.js
// module id = 1257
// module chunks = 1